import { useCallback, useState } from 'react';
import { Box } from '@mui/material';
import { Card } from 'components/@shared/Card';
import { changePassword } from 'services/authService';
import { BackdropLoader } from 'components/@shared/Loaders';
import { useNavigate, useParams } from 'react-router-dom';
import { PATH } from 'routes/path';
import { useDidMount } from 'hooks/useDidMount';
import { ChangePasswordForm } from 'components/Auth/ChangePasswordForm';

export const SetNewPasswordPage = () => {
    const [isLoading, setIsLoading] = useState(false);

    const { token, userId } = useParams();

    const navigate = useNavigate();

    const changePasswordHandler = useCallback(
        (newPassword: string) => {
            if (token && userId) {
                setIsLoading(true);
                changePassword({ newPassword, resetToken: token, userId })
                    .then(() => navigate(PATH.LOGIN))
                    .finally(() => setIsLoading(false));
            }
        },
        [navigate],
    );

    useDidMount(() => {
        if (!token || !userId) {
            navigate(PATH.ROOT);
        }
    });

    return (
        <Box px={2.5} py={2} display="flex" width="100%" height="100%" alignItems="center" justifyContent="center">
            <Card title="Reset Password">
                <ChangePasswordForm onChangePassword={changePasswordHandler} />
            </Card>
            {isLoading && <BackdropLoader />}
        </Box>
    );
};
